export const siteSettings = {
  name: "Zyra Markets",
  link: "https://zyramarkets.com",
  email: "support@zyramarkets.com",
  appLink: "https://app.zyramarkets.com",
};
